import global from './global'
import jobs from './jobs'
import travels from './travels'
import health from './health'
import fashion from './fashion'

export default { global, jobs, travels, health, fashion }



// WEBPACK FOOTER //
// ./src/services/index.js